import { WarningInfoDisclaimer } from '@client/components/WarningInfoDisclaimer';

/**
 * Surfaces the strategy-raised stale/inconsistent-data warnings
 * (`terms.dataWarnings`) above the projection — the engine kept the policy on
 * a legacy interpretation instead of silently reinterpreting its extracted
 * fields, and the user should refresh the extraction (typically by
 * re-uploading the illustration). Renders nothing for clean rows.
 */
export function ProjectionDataWarnings({ terms }: { terms: ClaimTerms }) {
  const warnings = terms.dataWarnings ?? [];
  if (warnings.length === 0) return null;

  return (
    <>
      {warnings.map(warning => (
        <WarningInfoDisclaimer
          key={warning}
          type="warning"
          bodyText={
            <p>
              <span className="font-semibold">Please note:</span> {warning}
            </p>
          }
        />
      ))}
    </>
  );
}
